import * as React from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useSelector } from 'react-redux';
import DatePickerIcon from '../../../../../../components/DatePickerIcon';
import { formatDate } from '../../../../../../services/functions';
import SendMessagePreviewModal from './SendMessagePreviewModal';

export default function DocumentButton(
  { name, disabled, handleDownload, handleShow, handleSend,
    handleRefresh = () => console.log('refreshFn'), notificationType = 'SAGR',
    onlySend = false }) {
  const [openPreviewModal, setOpenPreviewModal] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { order } = useSelector(state => state.orderData);
  const { seasonYear } = useSelector(state => state.app);
  const [sendNotificationType, setSendNotificationType] = React.useState(notificationType);
  let qualificationCard = null;

  if (name === 'Karta kwalifikacyjna') {
    qualificationCard = order.documents.filter(item => item.document_type === 'qualification_card')[0];
  };

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenPreviewModal = (type = notificationType) => {
    setSendNotificationType(type);
    setOpenPreviewModal(true);
  };

  const handleClosePreviewModal = () => setOpenPreviewModal(false);

  return (
    <div>
      {onlySend
        ? <>
          <Button
            disabled={disabled}
            onClick={() => handleOpenPreviewModal()}
            variant="contained"
          >
            {name}
          </Button>
        </>
        : <>
          <Button
            id="basic-button"
            disabled={disabled}
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            variant="contained"
            onClick={handleClick}
          >
            {name}
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            <MenuItem onClick={handleDownload}>
              <ListItemIcon>
                <FileDownloadIcon />
              </ListItemIcon>
              <ListItemText>
                  Pobierz
              </ListItemText>
            </MenuItem>
            <MenuItem onClick={handleShow}>
              <ListItemIcon>
                <RemoveRedEyeIcon />
              </ListItemIcon>
              <ListItemText>
                  Zobacz
              </ListItemText>
            </MenuItem>
            <MenuItem onClick={() => handleOpenPreviewModal(notificationType)}>
              <ListItemIcon>
                <ForwardToInboxIcon />
              </ListItemIcon>
              <ListItemText>
                Wyślij
              </ListItemText>
            </MenuItem>
            {qualificationCard
              ? <MenuItem onClick={() => handleOpenPreviewModal('SQCC')}>
                <ListItemIcon>
                  <ForwardToInboxIcon />
                </ListItemIcon>
                <ListItemText>
                  Wyślij wypełnioną kartę
                </ListItemText>
              </MenuItem>
              : null}
            { qualificationCard
              ? <MenuItem onClick={handleRefresh}>
                <ListItemIcon>
                  <RefreshIcon />
                </ListItemIcon>
                <ListItemText>
                    Resetuj
                </ListItemText>
              </MenuItem>
              : null}
            { qualificationCard
              ? <Stack
                direction="row"
                spacing={2}
                px={1}
                alignItems={'center'}
              >
                <DatePickerIcon
                  order={order}
                  tooltipTitle={'Termin na podpisanie karty'}
                  value={order.qualification_card_completing_date_to}
                  fieldName="completing_date_to"
                  formikFieldName="qualification_card_completing_date_to"
                  icon="mdi:calendar-clock-outline"
                  type="qualification_card"
                />
                <Typography>{formatDate(order.qualification_card_completing_date_to)}</Typography>
              </Stack>
              : null }
          </Menu>
        </>}

      {openPreviewModal
        ? <SendMessagePreviewModal
          handleSend={data => {
            handleSend(data);
            handleClosePreviewModal();
          }}
          handleClose={handleClosePreviewModal}
          fileNames={sendNotificationType === 'SQCD'
            ? []
            : sendNotificationType === 'SQCC'
              ? ['Karta Kwalifikacyjna']
              : (sendNotificationType !== 'MATE'
                ? [name]
                : seasonYear > 2026 ? ['abc', 'Załącznik zajęciowy', 'Harmonogram']
                  : ['abc', 'Załącznik zajęciowy'])}
          type={sendNotificationType}
        />
        : null}
    </div>
  );
};
